/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddApprovedEmailInfoRequest,
} from '../models/index';
import {
    AddApprovedEmailInfoRequestFromJSON,
    AddApprovedEmailInfoRequestToJSON,
} from '../models/index';

export interface AddApprovedEmailInfoOperationRequest {
    addApprovedEmailInfoRequest: AddApprovedEmailInfoRequest;
}

/**
 * 
 */
export class DevelopmentControllerApi extends runtime.BaseAPI {

    /**
     * Finds service provider automatically. Public for now
     * Add approved email for some service provider
     */
    async addApprovedEmailInfoRaw(requestParameters: AddApprovedEmailInfoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['addApprovedEmailInfoRequest'] == null) {
            throw new runtime.RequiredError(
                'addApprovedEmailInfoRequest',
                'Required parameter "addApprovedEmailInfoRequest" was null or undefined when calling addApprovedEmailInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/org/.private/approved-email-info`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddApprovedEmailInfoRequestToJSON(requestParameters['addApprovedEmailInfoRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Finds service provider automatically. Public for now
     * Add approved email for some service provider
     */
    async addApprovedEmailInfo(requestParameters: AddApprovedEmailInfoOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.addApprovedEmailInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
